import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth0Service } from 'src/app/auth/auth0.service';

@Component({
  selector: 'app-medshorts-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class MedshortsHomeComponent implements OnInit {
  constructor(
    private router: Router,
    private auth: Auth0Service,
  ) {}

  ngOnInit() {}

  navigateToSubPages(page) {
    if (page === 'pharmacy') {
      this.router.navigate(['/pharmacy-info']);
    } else if (page === 'manufacturer') {
      this.router.navigate(['/manufacturer-info']);
    }
  }
}
